angular.module('EdxStudentReportModule')
  .controller('EdxStudentReportController', [
    '$rootScope',
    '$scope',
    '$state',
    'studentApi',
    'edxStateParamsService',
    'timeframe',
    function (
      $rootScope,
      $scope,
      $state,
      studentApi,
      edxStateParamsService,
      timeframe) {

      var params = _.pick($state.params, ['districtId']);
      params.student_id = $state.params.studentId;
      params = _.extend(params, edxStateParamsService.getTimeframeParamsForEarlyHighlights());

      $scope.studentHighlightsPromise = studentApi.getStudentHighlights(params).then(function (studentData) {
         timeframe.getYearListSubject().onNext(studentData.years);

         // deprecated: use timeframe.getYearListSubject instead of broadcast
         $scope.$broadcast('updateYears', studentData.years);

         // TODO: don't use rootScope!!! Eventually want this controller to be
         // parent of the info-pane and this won't be needed. 
         $rootScope.studentImageUrl = studentData.image_url;

         return studentData;
      });
    }
  ]);
